import { useAuth0 } from "@auth0/auth0-react";
import localisations from "../../localisation";

import Button from "@mui/material/Button";

function SignOutButton() {
    const { logout } = useAuth0();
    const handleLogout = () => logout({ returnTo: window.location.origin });
    return (
        <Button color="inherit" onClick={handleLogout}>
            {localisations.navigation.signOut}
        </Button>
    );
}

export default SignOutButton;
